import { DealInformation } from "../types/deal";
import { apiSlice } from "../lib/baseQuery";
import { DealsEndpointTags } from "./utils";

const BASE_URL = "/api/deals";

export const dealsApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getDealInformationById: build.query<DealInformation, number>({
            query: (dealId: number) => BASE_URL + `/${dealId}`,
            providesTags: [DealsEndpointTags.GET_DEAL_INFO_BY_ID],
        }),
        createActiveDealManually: build.mutation<void, number>({
            query: (empresaId: number) => ({
                url: BASE_URL + `/${empresaId}`,
                method: "POST",
            }),
        })
    }),
});

export const {
    useGetDealInformationByIdQuery,
    useCreateActiveDealManuallyMutation,
} = dealsApi;